<div class="scroll-hider" @tooltip>
    <div class="content" >
        @for (f of data; track $index) {
            @if(f[0]) {
                <div class="section">
                    {{f[0] | translate}}
                </div>
            }
            @for (i of f[1]; track $index) {
                <a class="feature" [touchRouterLink]="localeService.getLink(i.link)" [routerLinkActive]="'active'" (click)="close()">
                    <app-icon [icon]="i.icon"></app-icon>
                    <div class="description">
                        <p class="title">
                            <span class="margin-right">{{i.title | translate}}</span>
                            <app-badge class="{{i.badge?.style}} lg">{{i.badge?.label | translate | uppercase}}</app-badge>
                        </p>
                        <p class="features">{{i.caption | translate}}</p>
                    </div>
                </a>
            }
        }
    </div>
</div>
